export default __webpack_public_path__ + "static/media/pic_10.dae5646d.jpg";